export const getCurrency = (money) =>
  !isNaN(money)
    ? Number(money).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      })
    : "--";

export const getPercentage = (value) =>
  !isNaN(value)
    ? Number(value / 100).toLocaleString("en-US", {
        style: "percent",
        minimumFractionDigits: 2,
      })
    : "--";

export function formatMoneyIntoFloat(number = "") {
  let treatedValue = `${number}`.replace(/\$/g, "");

  if (!treatedValue) {
    treatedValue = "0";
  }

  if (typeof number === "string") {
    treatedValue = treatedValue.replace("R$", "").trim().replace(",", ".");
  }

  const split = treatedValue.toString().split(".");

  if (split[1]) {
    const integer = split[0];
    const decimal = split[1].substring(0, 2);
    treatedValue = parseFloat(`${integer}.${decimal}`);
  } else {
    treatedValue = parseFloat(treatedValue / 100); //NOSONAR
  }

  // eslint-disable-next-line no-restricted-globals
  if (isNaN(treatedValue)) {
    treatedValue = 0;
  }

  return treatedValue;
}
